String.prototype.hashCode = function () {
    return this.split("").reduce(function (a, b) {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return '' + Math.abs(a & a);
    }, 0);
};

String.prototype.trimChars = function (char) {
    let str = this;
    // if (char === "]") char = "\\]";
    // if (char === "\\") char = "\\\\";

    char.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"); // escape

    return str.replace(new RegExp(
        "^[" + char + "]+|[" + char + "]+$", "g"
    ), "");
};

export function downloadXLSX(base64Data, name) {
    const blob =    new Blob([base64toBlob(base64Data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')], {});

    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = name+'.xlsx'
    link.click()
    URL.revokeObjectURL(link.href)
}

function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 1024;
    let byteCharacters = atob(base64Data);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);

        let bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

export function plural(number, zero, one, two, five, showZeroNumber = false) {
    number = Math.abs(number)
    let numStr = number.toString() + ' ';
    let ost = number % 100

    if (number === 0) {
        return showZeroNumber ? numStr + zero : zero;
    }
    if (ost >= 5 && ost <= 20) {
        return numStr + five
    }
    ost %= 10
    if (ost === 1) {
        return numStr + one
    }
    if (ost >= 2 && ost <= 4) {
        return numStr + two
    }

    return numStr + five
}

export function formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ` `);
}

export function scrollTableToEnd() {
    const posX = document.querySelector('.tbody-container').scrollWidth;

    document.querySelector('.tbody-container').scroll(posX, 0);
}
